'use client';

import _defineProperty from "/codebuild/output/src74/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src74/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["media"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.sort.js";
function replaceMediaQuery(query) {
  return query.replace("(min-width: ", "").replace("em)", "");
}
function sortMediaQueries(_ref) {
  var media = _ref.media,
    props = _objectWithoutProperties(_ref, _excluded);
  var breakpoints = Object.keys(media);
  var sortedMedia = breakpoints.sort(function (a, b) {
    return Number(replaceMediaQuery(a)) - Number(replaceMediaQuery(b));
  }).map(function (query) {
    return {
      query: query,
      styles: media[query]
    };
  });
  return _objectSpread(_objectSpread({}, props), {}, {
    media: sortedMedia
  });
}
export { sortMediaQueries };